import { render, staticRenderFns } from "./AssessDetails.vue?vue&type=template&id=41a3fac6&"
import script from "./AssessDetails.vue?vue&type=script&lang=js&"
export * from "./AssessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports